let windowHeight = $(window).height();
$(document).on("scroll", function () {
	let scrollTop = $(window).scrollTop();
	if (scrollTop > windowHeight) {
		$('.back-to-top').addClass('active');
	} else {
		$('.back-to-top').removeClass('active');
	}
});

// Click event to scroll to top
$(document).on("click", ".back-to-top", function(){
	$('html, body').animate({scrollTop : 0},800);
	return false;
});
